import React from "react"
import { Button, FormControl } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { debounce } from "../../lib/debounce"

export default class CustomerSeachPanel extends React.Component {

  constructor(props) {

    super(props)
    const { query: { searchTerm, businessId, fromDate, toDate } } = this.props

    this.state = {
      showFilter: true,
      businessId: businessId ? businessId : '',
      searchTerm: searchTerm ? searchTerm : '',
      fromDate: fromDate ? fromDate : '',
      toDate: toDate ? toDate : '',
    }

    this.debounceSearh = debounce(this.startSearchTerm, 1000)
  }

  toggleFiler = () => this.setState({ showFilter: !this.state.showFilter })

  businessIdChanged = businessId => {
    this.setState({ businessId })
    this.props.filterChanged('businessId', businessId)
  }

  searchTermChanged = searchTerm => {
    this.setState({ searchTerm })
    this.debounceSearh(searchTerm)
  }

  startSearchTerm = searchTerm => {
    this.props.filterChanged('searchTerm', searchTerm.trim())
  }

  fromDateChanged = fromDate => {
    this.setState({ fromDate })
    this.props.filterChanged('fromDate', fromDate)
  }

  toDateChanged = toDate => {
    this.setState({ toDate })
    this.props.filterChanged('toDate', toDate)
  }

  runClearFilters = () => {
    this.setState({
      businessId: '',
      searchTerm: '',
      fromDate: '',
      toDate: '',
    })
    this.props.doClearFilters()
  }

  renderForm = () => {

    const { businessId, searchTerm, fromDate, toDate } = this.state,
    { businesses } = this.props

    return (
      <div className="flex gap-8 items-center flex-wrap">

        <div className="w-full sm:w-60">
          <label>Search</label>
          <FormControl type="text" id='searchTerm'
            value={ searchTerm } placeholder="Customer name, phone number"
            onChange={e => this.searchTermChanged(e.target.value)}
          />
        </div>

        <div className="w-full sm:w-60">
          <label>Affiliation</label>
          <FormControl id='businessId' componentClass="select" 
            placeholder="Select an account"
            value={ businessId } 
            onChange={e => this.businessIdChanged(e.target.value)}>

            <option value=''>Choose account</option>
            { businesses.map(({ id, name, businessId }) => <option key={ id } value={ id }>
              { name } - { businessId } </option>
            )}
          </FormControl>
        </div>

        <div className="w-full sm:w-auto overflow-auto">
          <label>Date range</label>
          <div className="flex gap-8 items-center">

            <FormControl type="date"
              value={ fromDate } placeholder="From date"
              onChange={e => this.fromDateChanged(e.target.value)}
            />

            <FormControl type="date"
              value={ toDate } placeholder="To date"
              onChange={e => this.toDateChanged(e.target.value)}
            />
          </div>
        </div>
      </div>
    )
  }

  render() {

    const { showFilter } = this.state
    return (
      <div className="border rounded-10 p-10 mb-10">

        <div className="flex justify-between items-center gap-10">

          <span className="uppercase text-xs">Add filters</span>

          <div className="flex item-center gap-1 sm:gap-2.5">
            <Button bsStyle="default" onClick={ this.runClearFilters } className="font-size-13"
              title="Clear all filters">
              CLEAR FILTERS
            </Button>

            <Button title="Show/hide filters" onClick={ this.toggleFiler }>
              <FontAwesome name={ showFilter ? 'chevron-up' : 'chevron-down '} />
            </Button>
          </div>
        </div>

        { showFilter && this.renderForm() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Customers/CustomerSeachPanel.js